import * as Board from "@escapio/portal/components/board";
import {
	parse as parseHash,
	format as formatHash,
} from "@escapio/shared/state/urlHash";

export const format = formatHash({
	board: b => (b === Board.NONE ? null : b),
	cancelation: c => (c ? "1" : null),
});

export const parse = parseHash({
	board: b => (Board.isValid(b) ? b : Board.NONE),
	cancelation: () => true,
	// Backwards compatibility: replace old breakfast parameter with board.
	breakfast: ["board", () => "breakfast"],
	selectedStagePicture: id => +id,
});
